import styled from 'styled-components/native';

import { Colors } from 'theme/colors';

export const Banner = styled.View`
  background-color: ${Colors.black};
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  z-index: 1100;
`;

export const ErrorContainer = styled.View`
  margin: 30px auto 0px;
`;
